export const isPreciseLocationOutsideClick = (
  target: EventTarget | null,
  container: HTMLElement | null,
): boolean => {
  if (!(target instanceof Element)) return false
  if (container?.contains(target)) return false
  return true
}
